<template> </template>

<script>
export default {
  components: {},
  methods: {},
  data() {
    return {
      clientId: "bf79d19b-b0de-41f4-878a-b89e69430cfa",
      uiConfig: {
        header: true
        // for more UI options, see here: https://docs.dyte.io/javascript/reference/dyte-ui-config/
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
